import * as Yup from 'yup';

export const createMessageYopValidation = () => {
  return Yup.object().shape({
    messages: Yup.array().of(
      Yup.object().shape({
        message: Yup.string().required('required'),
      }),
    ),
  });
};
